import React, { useCallback, useMemo } from 'react';
import * as yup from 'yup';
import cc from 'classnames';
import { CircularProgress } from '@material-ui/core';
import Form from 'ui/Form/Form';
import Button, { Themes as ButtonThemes } from 'ui/Button/Button';
import { Textarea } from 'ui/Input';
import { requiredOnly, validationCallback } from 'utils/validation';
import { onlyNCharacters } from 'utils/formatters';
import ModalWindow from '../ModalWindow/ModalWindow';

import styles from './TransactionRejectionModal.module.css';

interface IRejection {
  rejectionReason: string;
}

type Props = {
  open: boolean;
  onClose: () => void;
  onReject: (values) => void;
};

const schema = yup.object().shape({
  rejectionReason: requiredOnly('Rejection Reason'),
});

const TransactionsRejectionModal = ({ open, onClose, onReject }: Props) => {
  const intialValues = useMemo(
    () => ({
      rejectionReason: '',
    }),
    [],
  );
  const validate = useCallback((values: IRejection) => validationCallback<IRejection>(schema)(values), []);

  const onSubmit = (values: IRejection) => {
    onReject(values);
    onClose();
  };

  return (
    <>
      <ModalWindow title="Request Rejection" open={open} onClose={onClose}>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          initialValues={intialValues}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} noValidate>
              <div className={cc(styles.fieldWrapper, styles.noBorder)}>
                <span className={styles.label}>Rejection Reason</span>
                <Textarea
                  name="rejectionReason"
                  label="Rejection Reason"
                  fieldProps={{
                    parse: onlyNCharacters(25),
                  }}
                />
              </div>
              <div className={styles.buttonsWrapper}>
                <Button type="button" theme={ButtonThemes.secondary} onClick={onClose}>
                  Cancel
                </Button>
                <Button type="submit" fullWidth disabled={submitting}>
                  {submitting ? <CircularProgress size={20} color="inherit" /> : 'Reject Request'}
                </Button>
              </div>
            </form>
          )}
        />
      </ModalWindow>
    </>
  );
};

export default TransactionsRejectionModal;
